import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, ExportModuleSourceResult } from '../types/showcase';

/**
 * Mutation: POST /api/eraf/catalog/module-source-bundles (queue #641 재사용 · queue #664
 * §UAT-2026-07-09-R664 §R664-4 — 레시피 "통째로 담기"). 성공 시 blob+filename 을 반환 —
 * 호출부(RecipeDetailPanel)가 브라우저 다운로드를 트리거한다. 신규 BE endpoint 0.
 */
export function useRecipeBundle() {
  return useMutation<ExportModuleSourceResult, ApiError, string[]>({
    mutationFn: (codes) => showcaseApi.exportModuleSourceBundle(codes),
    mutationKey: ['common-showcase', 'recipe-bundle'],
  });
}
